import { put, takeLatest } from 'redux-saga/effects';
import { apiSaga, apiSagaJob } from '../../../../root-sagas';
import { reports } from '../../../../api';
import { partnerManagement } from '../../../../api';
import { ti2 as ti2Apis } from '../../../../api';
import { _getAccountInfo } from '../../../GenerativeAI/__store__/partner-settings/edit-app-key-configuration-sagas.js';

import * as R from 'ramda';
function* onLocationChange({ payload }) {
  const pathname = R.pathOr('', ['location', 'pathname'], payload);

  if (pathname.includes('generative-ai/itineraryassist/downloads')) {
    yield apiSaga('genAi_downloadXLSX_loadPartners', partnerManagement.getPartners, [])

    const { companyId, ti2token } = yield _getAccountInfo();
    yield apiSaga('genAi_downloadXLSX_loadAllAppKeys', ti2Apis.getAllAppKeys, [{ companyId, ti2token }])
  }
}

function* triggerXLSXCreation({ payload }) {
  try {
    yield apiSagaJob('genAi_ItineraryAssist_createXLSX', reports.exportIAXLSX, [payload]);
  } catch (error) {
    yield put({ type: 'genAi_ItineraryAssist_createXLSX_FAILURE', error });
  }
}

const downloadXLSXSagas = [
  takeLatest('@@router/LOCATION_CHANGE', onLocationChange),
  takeLatest('genAi_ItineraryAssist_createXLSX', triggerXLSXCreation),
];

export default downloadXLSXSagas;